<template>
  <div class="outBox">
    <div class="leftBox">
      <div class="logo">
        <img src="../assets/login/login_logo_blue.png" alt="logo" />
      </div>
    </div>
    <div class="rightBox">
      <div class="form-container">
        <div class="content-box">
          <p class="system-name">{{ $t("title.loginTitle") }}</p>
          <div class="loginType">{{ $t("loginPage.userLogin") }}</div>
          <div class="line" style="display: flex">
            <div style="height: 2px; background: #015ac5; width: 30%"></div>
            <div
              style="
                height: 2px;
                background: rgba(83, 132, 190, 0.21);
                width: 70%;
              "
            ></div>
          </div>
          <div class="loginBox" v-if="loginType == 'normal'">
            <div class="inputBox" id="inputBox">
              <div>
                <div class="label">{{ $t("loginPage.username") }}</div>
                <div>
                  <el-input
                    class="login-input"
                    v-model="loginForm.username"
                    :maxlength="256"
                    :placeholder="$t('loginPage.pleaseInputUsername')"
                    :class="{ 'is-error': userNameEmpty }"
                    @change="userNameEmpty = false"
                  ></el-input>
                </div>
              </div>
              <div style="margin-top: 25px">
                <div class="label">{{ $t("loginPage.password") }}</div>
                <div>
                  <el-input
                    class="login-input"
                    :type="inputType"
                    v-model="loginForm.password"
                    :maxlength="256"
                    :placeholder="$t('loginPage.pleaseInputPassword')"
                    @keyup.enter.native="login()"
                    :class="{ 'is-error': pwdEmpty }"
                    @change="pwdEmpty = false"
                  >
                    <i
                      style="cursor: pointer; margin-right: 4px"
                      @click="inputTypeChange"
                      slot="suffix"
                      :class="
                        inputType == 'text'
                          ? 'HSIconfont hs-icon-show'
                          : 'HSIconfont hs-icon-hide'
                      "
                    ></i>
                  </el-input>
                </div>
              </div>
              <div style="margin-top: 25px" v-if="captchaSwitch">
                <div class="label">{{ $t("loginPage.verificationCode") }}</div>
                <div style="display: flex; align-items: center">
                  <el-input
                    class="login-input"
                    v-model="loginForm.verificationCode"
                    :maxlength="256"
                    :placeholder="$t('loginPage.pleaseInputVerificationCode')"
                    @keyup.enter.native="login()"
                    :class="{ 'is-error': verificationCodeEmpty }"
                    @change="verificationCodeEmpty = false"
                    style="margin-right: 15px"
                  >
                  </el-input>
                  <img
                    :src="verificationCodeUrl"
                    style="
                      width: 30%;
                      margin-top: -10px;
                      border: 1px solid #dcdfe6;
                    "
                    @click="getLoginCode"
                  />
                </div>
              </div>
              <div
                style="text-align: right; margin-top: 10px"
                v-if="userEmailVerificationStatus"
              >
                <el-button type="text" @click="buttonForgetPassword">{{
                  $t("loginPage.forgetPassword")
                }}</el-button>
              </div>
            </div>
            <div class="loginButtonClass">
              <el-button
                style="width: 100%"
                type="primary"
                @click="login"
                :disabled="submitted"
                :loading="submitted"
                >{{ $t("button.login") }}</el-button
              >
            </div>
          </div>

          <div class="qr-code-container" v-if="loginType == 'wx'">
            <div class="qr-code-style">
              <p></p>
              <p></p>
              <p></p>
              <p></p>
              <div
                id="wxQrcode"
                ref="wxQrcode"
                style="width: 182px; height: 182px"
              ></div>
              <div
                v-show="showMask"
                class="qrcode-mask"
                @click="handleRefreshQrcode"
              >
                <i
                  class="el-icon-refresh-right qrcode-invalid-icon"
                  style="font-size: 46px"
                ></i>
                <span class="qrcode-invalid-tips">{{
                  $t("loginPage.qrcodeInvalid")
                }}</span>
                <span class="qrcode-invalid-tips-bottom">{{
                  $t("loginPage.refreshQrcode")
                }}</span>
              </div>
            </div>
          </div>

          <div class="socTip">
            <span>{{ $t("loginPage.login tips 1") }}</span>
            <span class="textColor" @click="goToSoc('cloud')">{{
              $t("loginPage.login tips 2")
            }}</span>
            <span>{{ $t("loginPage.login tips 3") }}</span>
            <span class="textColor" @click="goToSoc('privacy')">{{
              $t("loginPage.login tips 4")
            }}</span>
            <span>{{ $t("loginPage.login tips 5") }}</span>
          </div>
          <!-- <el-divider v-if="wxSwitch" style="color:#e2e2e2">or</el-divider> -->
          <el-divider
            class="divider-or"
            style="color: #e2e2e2"
            v-if="azureLoginSwitch || wxSwitch || pingLoginSwitch"
            >or</el-divider
          >
          <div class="other-login">
            <div
              class="otherLoginButtonBox"
              v-if="loginType != 'ping' && pingLoginSwitch"
              @click="changeLogin('ping')"
            >
              <img src="../assets/login/ic_adeo.png" alt="" />
            </div>
            <div
              class="otherLoginButtonBox"
              v-if="loginType != 'microsoft' && azureLoginSwitch"
              @click="changeLogin('microsoft')"
            >
              <img src="../assets/login/ic_microsoft.png" alt="" />
            </div>
            <div
              class="otherLoginButtonBox"
              v-if="loginType != 'wx' && wxSwitch"
              @click="changeLogin('wx')"
            >
              <img src="../assets/login/ic_wechat.png" alt="" />
            </div>
            <div
              class="otherLoginButtonBox"
              v-if="loginType != 'normal'"
              @click="changeLogin('normal')"
            >
              <i class="HSIconfont hs-icon-a-Individualcenter"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-container">
        {{ $t("hanshow.copyright") }}
        <i class="HSIconfont hs-icon-banquan"></i>
        {{ $t("hanshow.year") }}
        {{ $t("hanshow.product") }}
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogForgetVisible"
      :title="$t('loginPage.verify')"
      width="500px"
      :close-on-click-modal="false"
      :close="buttonCancel"
    >
      <div style="padding: 20px">
        <div style="display: flex; align-items: center">
          <el-input
            class="code-input"
            v-model="dialogVerificationCode"
            :maxlength="256"
            :placeholder="$t('loginPage.pleaseInputVerificationCode')"
            @keyup.enter.native="login()"
            :class="{
              'is-error':
                dialogVerificationCodeEmpty || dialogVerificationCodeError,
            }"
            @change="
              dialogVerificationCodeEmpty = false;
              dialogVerificationCodeError = false;
            "
            style="margin-right: 15px"
          >
          </el-input>
          <img
            :src="dialogVerificationCodeUrl"
            style="width: 30%; margin-top: -10px; border: 1px solid #dcdfe6"
            @click="getDialogLoginCode"
          />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" id="dialogCancel" @click="buttonCancel">{{
          $t("button.cancel")
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          id="dialogConfirm"
          @click="buttonConfirm"
          >{{ $t("button.confirm") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import md5 from "js-md5";
// import aes from "@/utils/aes.js";
import { guid, isEmpty } from "@/utils/utils.js";
import QRCode from "qrcodejs2";
import { dataToDay } from "@/utils/utils.js";
import { Notification } from "element-ui";
export default {
  created() {
    this.loginType = this.$route.params.loginType
      ? this.$route.params.loginType
      : "normal";
    this.getLoginPageConfig().then(() => {
      if (this.loginType == "wx" && this.wxSwitch) {
        this.handleRefreshQrcode();
      } else {
        this.loginType = "normal";
      }
      if (this.captchaSwitch) {
        this.getLoginCode();
      }
    });
  },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        verificationCode: "",
      },
      // 密码输入框类型 ， 用于修改显示隐藏状态
      inputType: "password",

      // 登陆类型
      loginType: "normal",
      //登录成功定时器
      loginCallBackInterval: "",
      //二维码超时定时器
      qrcodeOverTimeInterval: "",

      //微信登录随机串
      wxLoginStr: "",
      //微信登录是否开启
      wxSwitch: false,
      //azure登录是否开启
      azureLoginSwitch: false,
      //ping登录是否开启
      pingLoginSwitch: false,
      pingLoginInfo: {},
      lastCheckTime: 0,
      showMask: false,
      verificationCodeUrl: "",
      verificationId: "",
      captchaSwitch: false,
      userNameEmpty: false,
      pwdEmpty: false,
      dialogVerificationCodeEmpty: false,
      dialogForgetVisible: false,
      dialogVerificationCode: "",
      dialogVerificationCodeUrl: "",
      dialogVerificationId: "",
      dialogVerificationCodeError: false,
      userEmailVerificationStatus: false,
      submitted: false,
    };
  },
  methods: {
    inputTypeChange() {
      this.inputType == "text"
        ? (this.inputType = "password")
        : (this.inputType = "text");
    },
    getLoginPageConfig() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getLoginPageConfig()
          .then((res) => {
            if (res.resultCode == 1001) {
              if (!isEmpty(res) && !isEmpty(res.data)) {
                this.wxSwitch = res.data.wechatSwitch ?? false;
                this.azureLoginSwitch = res.data.azureSSOSwitch ?? false;

                this.captchaSwitch = res.data.captchaSwitch ?? false;
                this.userEmailVerificationStatus =
                  res.data.userEmailVerificationStatus ?? false;

                const ssoConfig = res.data.SSOConfig;
                if (ssoConfig && ssoConfig.lm) {
                  if (ssoConfig.lm.configShow && ssoConfig.lm.switch) {
                    this.pingLoginInfo = ssoConfig.lm;
                    this.pingLoginSwitch = true;
                  } else {
                    this.pingLoginInfo = {};
                    this.pingLoginSwitch = false;
                  }
                } else {
                  this.pingLoginInfo = {};
                  this.pingLoginSwitch = false;
                }
              }
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    login() {
      // 如果当前处在正在提交中, 直接不执行
      if (this.submitted) {
        return;
      }
      // 设置 提交状态为true , 出现异常情况下将该值置为fals
      this.submitted = true;
      let errorFlag = false;
      if (!this.loginForm.username) {
        this.userNameEmpty = true;
        errorFlag = true;
      } else {
        this.userNameEmpty = false;
      }
      if (!this.loginForm.password) {
        this.pwdEmpty = true;
        errorFlag = true;
      } else {
        this.pwdEmpty = false;
      }
      if (this.captchaSwitch && !this.loginForm.verificationCode) {
        this.verificationCodeEmpty = true;
        errorFlag = true;
      } else {
        this.verificationCodeEmpty = false;
      }
      if (!errorFlag) {
        let submitInfo = {
          username: this.loginForm.username,
          password: md5(
            this.loginForm.password + this.loginForm.username
          ).toUpperCase(),
        };
        if (this.captchaSwitch) {
          submitInfo.validateCodeId = this.verificationId;
          submitInfo.validateCode = this.loginForm.verificationCode;
        }
        return new Promise((resolve, reject) => {
          this.$httpList
            .login(submitInfo)
            .then((res) => {
              if (res.resultCode == 1001) {
                Notification.closeAll();
                localStorage.setItem("as-username", res.data.username);
                //token 加密存储
                localStorage.setItem(
                  "accessToken",
                  // aes.encrypt(res.data.access_token)
                  res.data.access_token
                );
                if (localStorage.getItem("accessToken")) {
                  // //TODO  把加密后的accessToken 解密
                  this.$actions.setGlobalState({
                    accessToken: res.data.access_token,
                  });
                  /**
                   * 0 未开启   无需处理 正常登陆进入
                   * 1 用户自开启   默认进入输入验证码页面
                   * 2 强制开启    进入验证码页面
                   * 3 强制开启未绑定  进入强制绑定页面
                   * 4 已绑定未开启     无需处理  正常登陆进入
                   */
                  //Google登录注册
                  if ([1, 2].includes(res.data.googleType)) {
                    this.$router.push({
                      name: "GoogleLogin",
                      params: {
                        username: submitInfo.username,
                        userFirstLogin: JSON.parse(res.data?.userFirstLogin),
                        passwordModifyExpires: JSON.parse(
                          res.data?.passwordModifyExpires
                        ),
                      },
                    });
                  } else if (res.data.googleType == 3) {
                    this.$router.push({
                      name: "ForceBind",
                      params: {
                        username: submitInfo.username,
                        userFirstLogin: JSON.parse(res.data?.userFirstLogin),
                        passwordModifyExpires: JSON.parse(
                          res.data?.passwordModifyExpires
                        ),
                      },
                    });
                  } else if ([0, 4].includes(res.data.googleType)) {
                    this.$httpList.isHaveLicense().then((rs) => {
                      if (rs.resultCode == 1001) {
                        rs.data.expirationTime =
                          new Date(
                            dataToDay(rs.data.expirationTime) + " 00:00:00"
                          ).getTime() +
                          24 * 60 * 60 * 1000 -
                          1;
                        if (!rs.data.permanentAuthorization) {
                          if (new Date().getTime() < rs.data.expirationTime) {
                            this.$store.commit(
                              "config/changeTipsStatus",
                              false
                            );
                          }
                        } else {
                          this.$store.commit("config/changeTipsStatus", true);
                        }
                        if (
                          JSON.parse(res.data?.userFirstLogin) == true ||
                          JSON.parse(res.data?.passwordModifyExpires) == true
                        ) {
                          this.$router.push({
                            name: "forcePwdChange",
                            params: {
                              userFirstLogin: JSON.parse(
                                res.data?.userFirstLogin
                              ),
                              passwordModifyExpires: JSON.parse(
                                res.data?.passwordModifyExpires
                              ),
                            },
                          });
                        } else {
                          this.$router.push({
                            name: "Home",
                          });
                        }
                      }
                    });
                  }
                } else {
                  this.$notify({
                    type: "error",
                    message: this.$t("promptMessage.getTokenError"),
                  });
                  this.getLoginCode();
                  this.submitted = false;
                }
                resolve(res);
              }
            })
            .catch((err) => {
              const res = err.response;
              this.getLoginCode();
              this.submitted = false;
              reject(err);
            });
        });
      } else {
        this.submitted = false;
      }
    },
    changeLogin(data) {
      this.loginType = data;
      if (data == "wx") {
        this.handleRefreshQrcode();
      } else {
        window.clearInterval(this.loginCallBackInterval);
        this.showMask = false;
        if (this.$refs.wxQrcode) {
          this.$refs.wxQrcode.innerHTML = "";
        }
        if (data == "microsoft") {
          this.toAzureLogin();
        } else if (data == "ping") {
          this.toSSOLogin();
        } else {
          //普通登录
        }
      }
    },
    handleRefreshQrcode() {
      this.showMask = false;
      this.wxLoginStr = guid();
      this.$nextTick(() => {
        this.getQrCode();
        //调用微信获取二维码 内容 然后绘制二维码
      });
    },
    getQrCode() {
      return new Promise((resolve, reject) => {
        let submitInfo = {
          key: "wxlogin",
          loginStr: this.wxLoginStr,
        };
        this.$httpList
          .getWxQrCodeContent(submitInfo)
          .then((res) => {
            if (res.resultCode == 1001) {
              this.$refs.wxQrcode.innerHTML = ""; // 清除二维码方法
              new QRCode("wxQrcode", {
                text: res.data.qrCodeContent,
                width: 182,
                height: 182,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
              });
              // 清除div title
              document.getElementById("wxQrcode").title = "";
              this.lastCheckTime = Date.now();
              this.loginCallBackInterval = window.setInterval(
                () => this.checkLoginStatus(),
                1000
              );
            }

            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      }).then(() => {});
    },
    checkLoginStatus() {
      const currentTime = Date.now();
      if (currentTime - this.lastCheckTime > 60000) {
        window.clearInterval(this.loginCallBackInterval);
        this.showMask = true;
        return;
      }
      this.wxLogin().then((rs) => {
        if (rs.resultCode == 1001) {
          window.clearInterval(this.loginCallBackInterval);
          this.$notify.success({
            message: this.$t("wechat.loginSuccess"),
          });

          localStorage.setItem("as-username", rs.data.username);
          //token 加密存储
          localStorage.setItem("accessToken", rs.data.access_token);
          if (localStorage.getItem("accessToken")) {
            this.$actions.setGlobalState({
              accessToken: rs.data.access_token,
            });
            if (
              JSON.parse(rs.data?.userFirstLogin) ||
              JSON.parse(rs.data?.passwordModifyExpires)
            ) {
              localStorage.setItem(
                "as-pwdFlag",
                JSON.stringify({
                  userFirstLogin: rs.data?.userFirstLogin,
                  passwordModifyExpires: rs.data?.passwordModifyExpires,
                })
              );
              this.$router.push({
                name: "forcePwdChange",
                params: {
                  userFirstLogin: JSON.parse(rs.data?.userFirstLogin),
                  passwordModifyExpires: JSON.parse(
                    rs.data?.passwordModifyExpires
                  ),
                },
              });
            } else {
              this.$router.push({
                name: "Home",
              });
            }
          } else {
            console.log("获取token失败");
          }
        }
      });
    },
    wxLogin() {
      return new Promise((resolve, reject) => {
        let submitInfo = {
          loginStr: this.wxLoginStr,
        };
        this.$httpList
          .wxLogin(submitInfo)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    toAzureLogin() {
      let requestForm = document.createElement("form");
      requestForm.style = "display:none";
      requestForm.method = "get";
      requestForm.action = "/proxy/allstar/v2/azure/login";
      requestForm.target = "_self";
      document.body.appendChild(requestForm);
      requestForm.submit();
      document.body.removeChild(requestForm);
    },
    toSSOLogin() {
      if (this.pingLoginSwitch) {
        window.location.href = this.pingLoginInfo.loginAddress;
      }
    },
    goToSoc(type) {
      this.$router.push({
        name: "Soc",
        params: { type: type, loginType: this.loginType },
      });
    },
    getLoginCode() {
      this.$httpList.getLoginCode(300,this.verificationId).then((res) => {
        if (res.resultCode == "1001") {
          this.verificationCodeUrl = res.data.captcha;
          this.verificationId = res.data.id;
        }
      });
    },
    getDialogLoginCode() {
      this.$httpList.getLoginCode(300).then((res) => {
        if (res.resultCode == "1001") {
          this.dialogVerificationCodeUrl = res.data.captcha;
          this.dialogVerificationId = res.data.id;
        }
      });
    },
    buttonForgetPassword() {
      // this.dialogForgetVisible=true;
      // this.getDialogLoginCode();
      this.$router.push({
        name: "forgetPassword",
      });
    },
    buttonConfirm() {
      if (this.dialogVerificationCode) {
        this.$httpList
          .validateVerficationCode({
            validateCodeId: this.dialogVerificationId,
            validateCode: this.dialogVerificationCode,
          })
          .then((res) => {
            if (res.resultCode == 1001) {
              this.$router.push({
                name: "forgetPassword",
              });
            } else {
              this.dialogVerificationCodeError = true;
            }
          });
      } else {
        this.dialogVerificationCodeEmpty = true;
      }
    },
    buttonCancel() {
      this.dialogForgetVisible = false;
      this.dialogVerificationCode = "";
      this.dialogVerificationCodeEmpty = false;
    },
  },
  destroyed() {
    window.clearInterval(this.loginCallBackInterval);
  },
};
</script>

<style lang="scss" scoped>
.el-icon-pwd-hid {
  margin-right: 4px;
}

.el-icon-pwd-show {
  margin-right: 4px;
}

.outBox {
  display: flex;
  height: 100%;
  margin: 0px;
  padding: 0px;
  min-height: 680px;
  .leftBox {
    width: 60%;
    background: url("~@/assets/login/newLogin.png") no-repeat center center;
    background-size: cover;
    position: relative;
    .logo {
      position: absolute;
      left: 52px;
      top: 56px;
      img {
        width: 133px;
      }
    }
  }
  .rightBox {
    background-color: #fff;
    width: 40%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    .form-container {
      flex-grow: 1;
      width: 70%;
      flex-direction: row;
      display: flex;
      align-items: center;
      .content-box {
        padding-top: 50px;
        width: 100%;
        .system-name {
          font-size: 28px;
          color: $primary;
          margin: 0;
          font-weight: 600;
          margin-bottom: 36px;
        }
      }
    }
    .loginType {
      font-size: 20px;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
      margin-bottom: 6px;
    }
    .loginBox {
      display: flex;
      flex-direction: column;
      .inputBox {
        padding-top: 46px;
        display: flex;
        flex-direction: column;

        ::v-deep .el-input__suffix {
          display: flex;
          align-items: center;
        }

        ::v-deep .el-input__inner {
          height: 38px;
          border-radius: 8px;
        }
      }
    }
    .loginButtonClass {
      padding-top: 30px;
      .el-button {
        height: 42px;
      }
    }
    .label {
      // height: 14px;
      font-size: 12px;
      font-weight: 500;
      color: #585b61;
      line-height: 14px;
      margin-bottom: 8px;
    }
    .footer-container {
      flex-shrink: 0;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      padding: 32px 0;
    }
  }
}

.el-divider__text {
  color: #c5c5c5;
}
::v-deep .el-input__inner {
  border-radius: 8px !important;
}
::v-deep .el-button {
  border-radius: 8px !important;
}
.socTip {
  padding-top: 10px;
  text-align: center;
  line-height: 150%;
  .textColor {
    color: $primary;
    cursor: pointer;
  }
  :deep(.textColor) {
    color: $primary;
    cursor: pointer;
  }
  .textColor:hover {
    text-decoration: underline;
  }
}
.divider-or {
  margin-top: 56px;
  margin-bottom: 26px;
}
.other-login {
  display: flex;
  align-items: center;
  justify-content: center;
  .otherLoginButtonBox {
    margin-left: 9px;
    margin-right: 9px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }
    i {
      font-size: 35px;
      color: $primary;
    }
    img {
      width: 35px;
    }
  }
}
.qr-code-container {
  display: flex;
  padding-top: 78px;
  padding-bottom: 7px;
  justify-content: center;
  .qr-code-style {
    padding: 17px;
    border: 1px solid $border-color;
    border-radius: 7px;
    position: relative;
    p {
      position: absolute;
      margin: 0;
      content: "";
      width: 25px;
      height: 25px;
    }
    p:nth-of-type(1) {
      left: -2px;
      top: -2px;
      border-top-left-radius: 7px;
      border-top: 2px solid $primary;
      border-left: 2px solid $primary;
    }
    p:nth-of-type(2) {
      right: -2px;
      top: -2px;
      border-top-right-radius: 7px;
      border-top: 2px solid $primary;
      border-right: 2px solid $primary;
    }
    p:nth-of-type(3) {
      left: -2px;
      bottom: -2px;
      border-bottom-left-radius: 7px;
      border-bottom: 2px solid $primary;
      border-left: 2px solid $primary;
    }
    p:nth-of-type(4) {
      right: -2px;
      bottom: -2px;
      border-bottom-right-radius: 7px;
      border-bottom: 2px solid $primary;
      border-right: 2px solid $primary;
    }

    // background: linear-gradient(to left, $primary, $primary) left top no-repeat,
    //   linear-gradient(to bottom, $primary, $primary) left top no-repeat,
    //   linear-gradient(to left, $primary, $primary) right top no-repeat,
    //   linear-gradient(to bottom, $primary, $primary) right top no-repeat,
    //   linear-gradient(to left, $primary, $primary) left bottom no-repeat,
    //   linear-gradient(to bottom, $primary, $primary) left bottom no-repeat,
    //   linear-gradient(to left, $primary, $primary) right bottom no-repeat,
    //   linear-gradient(to left, $primary, $primary) right bottom no-repeat;
    // background-size: 2px 25px, 25px 2px, 2px 25px, 25px 2px;
    .qrcode-mask {
      position: absolute;
      width: 182px;
      height: 182px;
      opacity: 0.95;
      background: #fefefe;
      top: 17px;
      .qrcode-invalid-icon {
        position: absolute;
        top: 35px;
        left: 67px;
        width: 45px;
        height: 45px;
        color: #000;
      }
      .qrcode-invalid-tips {
        position: absolute;
        top: 106px;
        width: 182px;
        color: #000;
        font-size: 16px;
        text-align: center;
        font-weight: 500;
        line-height: 16px;
      }
      .qrcode-invalid-tips-bottom {
        position: absolute;
        top: 132px;
        width: 182px;
        color: #000;
        text-align: center;
        line-height: 14px;
        font-size: 12px;
      }
    }
  }
}
.is-error {
  ::v-deep.el-input__inner {
    border-color: #f56c6c;
  }
}
</style>
<style lang="scss">
.socTip {
  padding-top: 10px;
  text-align: center;
  line-height: 150%;
  .textColor {
    color: $primary;
    cursor: pointer;
  }
  .textColor:hover {
    text-decoration: underline;
  }
}
</style>
